// extracted by mini-css-extract-plugin
export default {"ctaPanel":"_3K64euxj","ctaInner":"_1m2p2cVQ","ctaButton":"_34yU-Krr"};